import CookieUtils from '@/utils/CookieUtils'

// ******************************************** //

/**
 * Config: Default Locale
 */
const defaultLocale = 'ja'

// ******************************************** //

// Sets the current locale based on cookie if exist
// const currentLocale = CookieUtils.getCookie('locale') ? CookieUtils.getCookie('locale') : defaultLocale
const currentLocale = defaultLocale
// Sets current locale to cookie
CookieUtils.setCookie('locale', currentLocale)

export default {
  currentLocale,
  availableLocales: [
    { text: 'EN', value: 'en' },
    { text: '繁', value: 'zhHant' },
    // { text: '简体中文', value: 'zhHans' },
    { text: '日本語', value: 'ja' },
  ]
}
